import React from 'react';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {usePostApi} from 'common/hooks/usePostApi';
import api from 'api';
import {unpackId} from 'common/diplomatIdUtil';
import {layoutActions} from 'features/layout/redux';
import {useDispatch} from 'react-redux';
import MoveDialog from 'features/layout/DialogRoutes/dialogs/MoveDialog';

type MoveKeysDialogProps = {
   data: INav;
   header: string;
   onClose: () => void;
};

const MoveKeysDialog = ({data, header, onClose}: MoveKeysDialogProps) => {
   const dispatch = useDispatch();
   const {id: keyId} = unpackId(data.id);
   const {request: move} = usePostApi(api.keysMove, {
      onSuccess: () => {
         dispatch(layoutActions.loadTreeNav());
         onClose();
      },
      onFailure: onClose,
   });
   const handleMove = (parentFolderId: string) => {
      move(
         JSON.stringify({
            keyIds: [keyId],
            folderId: parentFolderId,
         })
      );
   };

   return <MoveDialog data={data} header={header} onConfirm={handleMove} onClose={onClose} />;
};

export default MoveKeysDialog;
